import { IState } from '../store';

export const getExportLinks = (state: IState) => {
  return state.offerData.offer.exportLinks;
};
